import { NgModule, LOCALE_ID, Injector} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './core/services/auth/auth.service';
import { AuthTokenInterceptor } from './core/interceptors/auth-token.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './core/shared/shared.module';
import { TranslateService } from './core/services/translate/translate.service';
import { TriageService } from './core/services/triage/triage.service';
import { LoadingComponent } from "./core/shared/components/loading/loading.component";
import { LockSessionService } from './core/services/auth/lock-session.service';
import { BackButtonNavigatorInterceptor } from './core/interceptors/back-button-navigator.interceptor';


/** LocaleData Español */
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { GlobalInjector } from './core/utils/global.injector';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
registerLocaleData(localeEsMx, 'es-MX');

@NgModule({
  declarations: [
    AppComponent    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    HttpClientModule,
    LoadingComponent,
],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es-MX' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackButtonNavigatorInterceptor,
      multi: true
    },
    AuthService,
    TranslateService,
    TriageService,
    LockSessionService    
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    GlobalInjector.setInjector(injector);
  }
}
